// Whop removed — this is now a no-op so existing imports keep working without any external tracking.
export const trackWhop = () => {};
